import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../../requets/shared/user.service';
import { BossDependence } from '../../requets/shared/model/boss-dependence.model';
import { Role } from '../../requets/shared/model/Role.model';
import { RequestService } from '../../requets/shared/request.service';
import { FilterRequest } from '../../requets/shared/model/filter-request.model';
import { RequestReponse } from '../../requets/shared/model/request-reponse.model';
import { UtilityService } from 'src/app/core/shared/utility.service';
import { RoleInformation } from 'src/app/core/shared/role-information.model';
import { RequetsComponent } from '../../requets/requets.component';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { Employee } from '../../requets/shared/model/employee.model';
import { AssigmentEvaluator } from '../shared/assigment-evaluator.model';
import { AssesmentsService } from '../shared/assesments.service';
import {  Router } from '@angular/router';
import { SelectEvaluatorDialogComponent } from 'src/app/core/modal/select-evaluator-dialog/select-evaluator-dialog.component';

@Component({
  selector: 'app-assign-evaluator',
  templateUrl: './assign-evaluator.component.html',
  styleUrls: ['./assign-evaluator.component.scss']
})
export class AssignEvaluatorComponent implements OnInit {

  roles: Role[] = [];
  bossDeependence: BossDependence;
  viceFaculty: any;
  Requests: RequestReponse[];
  currentRol: Role;
  tipoRol: number;
  enabledSpinner = false;
  fileSearch: FilterRequest;
  rolesApplication: Role[] = [];
  employees: Employee[] = [];
  countProccess = 0;
  dialogPendingOpen = false;
  isPifle = false;

  @ViewChild(RequetsComponent) requetsComponent: RequetsComponent;

  constructor(private userService: UserService, private requestService: RequestService,
               private utilityService: UtilityService, private dialog: MatDialog,
               private router: Router,
               private assessmentService: AssesmentsService) { }

  ngOnInit() {
    this.getUserInformation();
  }

  private getUserInformation() {
    const userid =  null;
    const cedula =  localStorage.getItem('cedula');
    this.userService.getUserInformation(userid, cedula).subscribe(
      (result) => {
        if (result.data) {
            this.roles =  result.data.roles as Role[];
            this.bossDeependence = result.data.jefeDepartamento as BossDependence;
            this.viceFaculty = result.data.vice.facultad;
            const roleInformation: RoleInformation = this.utilityService.validateRole(this.roles, 2);
            this.rolesApplication = roleInformation.roles;
            this.currentRol = roleInformation.currentRol;
            this.tipoRol = roleInformation.tipoValidation;
            if ( this.tipoRol === 0) {
              const parameters = {
                tipo: 'info',
                mensaje: 'Usted no posee el rol adecuado para acceder a esta opción'
              };
              this.router.navigate(['message'], {queryParams : parameters});
            }
            this.generateFirstSearch();
        }
      }
    );
  }


  changeSpinner(estado: boolean) {
    this.enabledSpinner = estado;
  }

  private openDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { tittle: 'Seleccionar evaluador' , data:  this.employees, codigo: 'numeroIdentificacion', nombre: 'nombres'};
    dialogConfig.width = '70%';
    const dialogRef = this.dialog.open(SelectEvaluatorDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
        if (value !== null) {
            if (value.item) {
             const solicitudes = this.requetsComponent.selection.selected.map(
                (item) => {
                  return item.solicitud;
                }
              );
              const cedula = value.item.numeroIdentificacion;
              const assigmentEvaluator =  new AssigmentEvaluator();
              assigmentEvaluator.cedulaEvaludor = cedula;
              assigmentEvaluator.solicitudes = solicitudes;
              this.enabledSpinner = true;
              this.assessmentService.sendEvaluators(assigmentEvaluator).subscribe(
                (result) => {
                  this.enabledSpinner = false;
                  this.refreshSearch();
                }
              );
            }
        }
    });
  }

  asssignEvaluator() {
      this.openDialog();
  }

  refreshSearch() {
    this.sendFilter(this.fileSearch);
  }
 sendFilter(event: FilterRequest) {
  event.estado = 'C';
  event.excluirEstado = false;
  event.tipoResultado = 2;
  if (this.viceFaculty !== undefined) {
    event.facultad = this.viceFaculty;
  }
  this.enabledSpinner = true;
  this.fileSearch = event;
  this.isPifle = this.fileSearch.tipo === 'PRUEBA LENGUA EXTRANJERA' ? true : false;
  if (this.currentRol.rol !== this.utilityService.rolCoordinador) {
    event.evaluador = localStorage.getItem('cedula');
  }

  if (this.currentRol.rol === this.utilityService.rolCoordinador) {
    if (this.fileSearch.tipo === undefined) {
      this.fileSearch.tipo = 'MATERIA LENGUA EXTRANJERA';
    }
    event.tipo = this.fileSearch.tipo;
    this.requestService.getRequestAssignmentLeng(event).subscribe(
      (result) => {
        if (result.data) {
          this.Requests = result.data as RequestReponse[];
        }
        this.enabledSpinner = false;
      }
    );
  } else {
    this.requestService.getRequestAssignment(event).subscribe(
      (result) => {
        if (result.data) {
          this.Requests = result.data as RequestReponse[];
        }
        this.enabledSpinner = false;
      }
    );
  }
}
validateSeletion(): boolean {
  if (this.requetsComponent) {
    if (this.requetsComponent.selection.selected.length > 0) {
      return false;
    }
  }
  return true;
}
private generateFirstSearch() {
  const filterRequest = new FilterRequest();
  filterRequest.excluirTipo = true;
  this.sendFilter(filterRequest);
}

}
